module.exports = __webpack_public_path__ + "static/burdock_board_large.4e06f9b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/boards/burdock_board_large.jpg
// module id = 628
// module chunks = 216635586879231